<p-confirmPopup></p-confirmPopup>
<custom-table [config]="customTable">
</custom-table>

<section>
    <form [formGroup]="categorizacionForm"(ngSubmit)="onSubmit()" >

        <p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="true" [maximizable]="true" 
            [breakpoints]="{'960px': '100vw'}" [style]="{width: '50vw'}">
            <ng-template pTemplate="header">
				<CustomTitle [title]="formTitle" />
			</ng-template>

            <ng-template pTemplate="content">
                <div class="grid formgrid p-fluid">
                    <div class="field col-12">
                        <label class="ml-3" for="descripcion">Descripcion<span style="color: red">*</span></label>
                        <input pInputText formControlName="descripcion" id="descripcion" type="text"/>
                        <ng-container *ngIf="categorizacionForm.get('descripcion')?.invalid && categorizacionForm.get('descripcion')?.touched">
                            <app-form-group-error-message [control]="categorizacionForm.get('descripcion')"></app-form-group-error-message>
                        </ng-container>
                    </div>
                </div>
            </ng-template>

            <ng-template pTemplate="footer">
                <div class="field col-12">
                    <div class="flex justify-content-between">
                        <button pButton type="button" [label]="'form.button.limpiar' | translate" iconPos="right" icon="pi pi-eraser" class="tax-app-button"
							style="width: 16rem;" (click)="resetForm()"></button>
						<button pButton type="submit" [label]="'form.button.guardar' | translate" icon="pi pi-save" iconPos="right" class="tax-app-button"
							style="width: 16rem;" [disabled]="!ls.hasRole(role.ADMIN_TRAM)"></button>
                    </div>
                </div>
            </ng-template>
        </p-dialog>

    </form>
</section>

<app-admin-categorizaciones-historico></app-admin-categorizaciones-historico>
